import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { getClassroom } from '@app/classrooms/_store/classroom/classroom.selectors';
import {
  clearClassroomParticipants,
  loadClassroomParticipants,
  loadNextPageClassroomParticipants,
} from '@app/classrooms/_store/participants';
import {
  getClassroomParticipants,
  getClassroomParticipantsIsNotEmpty,
  getClassroomParticipantsLoaded,
  getClassroomParticipantsLoading,
  getClassroomParticipantsPagination,
} from '@app/classrooms/_store/participants/participants.selectors';
import { AccountService, ContextService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Store } from '@ngrx/store';
import { Classroom, ClassroomParticipant, FindAccountStrategyEnum, IPagination, User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, switchMap, tap } from 'rxjs';

// Store

import { takeUntil } from 'rxjs/operators';
import {ErrorNotificationService} from "@shared/error-notification/error-notification.service";

@Component({
  selector: 'app-classroom-participants-page',
  templateUrl: './classroom-participants-page.component.html',
  styleUrls: ['./classroom-participants-page.component.scss'],
  /** TODO: C onPush вообще не работает компонент pagination. Надо исправить компонент */
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomParticipantsPageComponent extends ChangableComponent implements OnInit, OnDestroy {
  public participants: ClassroomParticipant[];
  public loading$: Observable<boolean>;
  public loaded$: Observable<boolean>;
  public notEmpty$: Observable<boolean>;
  public pagination$: Observable<IPagination>;
  public me: User;
  public inviteModal = false;
  public classroom: Classroom;

  public deletedUsers: string[] = [];

  constructor(
    private store: Store,
    public errorNotificationService: ErrorNotificationService,
    public deviceService: DeviceDetectorService,
    protected cdr: ChangeDetectorRef,
    private contextService: ContextService,
    private accountService: AccountService,
  ) {
    super(cdr);
  }

  ngOnInit(): void {
    this.store.dispatch(loadClassroomParticipants());
    this.store
      .select(getClassroomParticipants)
      .pipe(
        switchMap((data) => {
          this.participants = data;
          const userIds = [...data.map((p) => p.user_id)];
          return this.accountService
            .findAccounts({ use: FindAccountStrategyEnum.id, id: userIds }, { page: 1, pageSize: userIds.length })
            .pipe(
              tap((response) => {
                const users = response.results;
                this.participants.map((p) => (p.user = users.find((u) => u.id === p.user_id)));
              }),
            );
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        }
      });
    this.loaded$ = this.store.select(getClassroomParticipantsLoaded);
    this.loading$ = this.store.select(getClassroomParticipantsLoading);
    this.pagination$ = this.store.select(getClassroomParticipantsPagination);
    this.notEmpty$ = this.store.select(getClassroomParticipantsIsNotEmpty);
    this.deletedUsers = [];
    this.store
      .select(getClassroom)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (classroom) => (this.classroom = classroom),
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        }
      });

    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => (this.me = me),
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.deletedUsers = [];
    this.store.dispatch(clearClassroomParticipants());
  }

  public trackParticipantsByFn(index, item: ClassroomParticipant): string {
    return item.id;
  }

  public nextPage() {
    this.store.dispatch(loadNextPageClassroomParticipants());
  }

  public get isTeacher(): boolean {
    return AccountService.isAsIfTeacher(this.me);
  }

  public onInvite(): void {
    this.openInviteModal();
  }

  public openInviteModal() {
    this.inviteModal = true;
  }

  public closeInviteModal(event?: any) {
    this.inviteModal = false;
  }

  public onParticipantsInvited(participants: ClassroomParticipant[]) {
    this.store.dispatch(loadClassroomParticipants());
  }
}
